import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17b1e99a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "skeletondialog"
}
const _hoisted_2 = { class: "skeletondialog__header header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header__left header__control" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "javascript:void(0);",
    class: "back-link"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "icon icon-back" })
  ])
], -1))
const _hoisted_4 = { class: "header__mid header__control" }
const _hoisted_5 = { class: "contact-wrapper" }
const _hoisted_6 = { class: "img" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header__right header__control" }, null, -1))
const _hoisted_8 = {
  key: 0,
  class: "skeletondialog__body"
}
const _hoisted_9 = {
  key: 1,
  class: "d-skeletondialog"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-skeletondialog__header header" }, null, -1))
const _hoisted_11 = {
  key: 0,
  class: "d-skeletondialog__body"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_lazy_image = _resolveComponent("app-lazy-image")!
  const _component_app_skeleton_message = _resolveComponent("app-skeleton-message")!
  const _component_app_message_input = _resolveComponent("app-message-input")!

  return (_ctx.mainStore.isMobile)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_app_lazy_image, {
                  url: _ctx.photoUrl,
                  key: _ctx.photoUrl,
                  alt: "contact photo"
                }, null, 8, ["url"])
              ]),
              _createElementVNode("h5", null, _toDisplayString(_ctx.title), 1)
            ])
          ]),
          _hoisted_7
        ]),
        (!_ctx.hideSkeletons)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(_component_app_skeleton_message, { my: "" }),
              _createVNode(_component_app_skeleton_message, { my: "" }),
              _createVNode(_component_app_skeleton_message),
              _createVNode(_component_app_skeleton_message, { my: "" }),
              _createVNode(_component_app_skeleton_message),
              _createVNode(_component_app_skeleton_message, { my: "" })
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_app_message_input, {
          class: "msg-input",
          disabled: true
        })
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_9, [
        _hoisted_10,
        (!_ctx.hideSkeletons)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createVNode(_component_app_skeleton_message, { my: "" }),
              _createVNode(_component_app_skeleton_message, { my: "" }),
              _createVNode(_component_app_skeleton_message),
              _createVNode(_component_app_skeleton_message, { my: "" }),
              _createVNode(_component_app_skeleton_message),
              _createVNode(_component_app_skeleton_message, { my: "" })
            ]))
          : _createCommentVNode("", true)
      ]))
}